import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";

const AdminRoute = () => {
  const { accessToken } = useSelector((state) => state.auth);
  const { role } = useSelector((state) => state.user);

  if (!accessToken || role !== "admin") {
    return <Navigate to="/" replace={true} />;
  }

  return <Outlet />;
};

export default AdminRoute;
